import React from 'react';
import PropTypes from 'prop-types';

export default (Component) => {
    class withCloseOnOuterClick extends React.Component {
        constructor(props) {
            super(props);
            this.setWrapperRef = (el) => { this.wrapperRef = el; };
            this.handleClickOutside = (event) => {
                if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                    this.props.closeControl(event);
                }
            };
        }

        componentDidMount() {
            document.addEventListener('click', this.handleClickOutside);
        }

        componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        }

        render() {
            const refType = typeof Component === 'function' ? 'inputRef' : 'ref';
            return (
                <Component
                    { ...{ [refType]: this.setWrapperRef, ...this.props } }
                />
            );
        }
    }

    withCloseOnOuterClick.propTypes = {
        closeControl: PropTypes.func.isRequired
    };

    return withCloseOnOuterClick;
};
